import api from '@/apis/di/defaultAccountAPI.js';
import CrudCache from '@/stores/crudBaseCache.js';

var crud = new CrudCache('defaultAccountCache', api);

const state = {
  ...crud.state,
  _config: {
    table: 'sys_ref_type',
    field: {
      key: 'ref_type',
      //   code: '',
      name: 'ref_type_name',
      //   quickFollow: '',
    },
  },
};

const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  updateItemCombo(context, res) {
    //cập nhật danh sách
    context.commit('updateItem', res);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
